import GetSupport from ".";

export default function GetSupportExamples() {
  return <GetSupport />;
}
